var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"solo":"","hide-details":"","label":"Sort","items":_vm.items,"value":_vm.value},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }